import React from "react";
import "./AccessHold.css";

const AccessHold = () => {
  return (
    <div className="hold-container">
      <div className="hold-card">
        <img
          src="https://cdn-icons-png.flaticon.com/512/992/992700.png"
          alt="Hold"
          className="hold-icon"
        />
        <h2 className="hold-title">Access On Hold</h2>
        <p className="hold-text">
          Your account access is temporarily on hold due to unpaid installments.
          Please clear your dues to regain full access.
        </p>
      </div>
    </div>
  );
};

export default AccessHold;
